import React from 'react';
import { Notification } from '@common-fe/common-fe';

import { NotificationType } from '../notification.types';

import NotificationDetails from './NotificationDetails';
import NotificationModalWrapper from './NotificationModalWrapper';

interface Props {
  notification?: Notification;
  setOpenModal: (value: boolean) => void;
  dismissNotification: (id?: string) => void;
  openModal: boolean;
  onGoToPage?: () => void;
  currentType?: NotificationType;
  isPageLinkHidden?: boolean;
}

const NotificationModal: React.FC<Props> = ({
  notification,
  currentType,
  setOpenModal,
  dismissNotification,
  openModal,
  onGoToPage,
  isPageLinkHidden,
}) => (
  <NotificationModalWrapper
    visible={openModal}
    setOpenModal={() => setOpenModal(false)}
  >
    <NotificationDetails
      data={notification}
      isPageLinkHidden={isPageLinkHidden}
      currentType={currentType}
      onGoToPage={onGoToPage}
      onCancel={() => {
        setOpenModal(false);
      }}
      dismissNotification={dismissNotification}
    />
  </NotificationModalWrapper>
);

export default NotificationModal;
